import * as React from "react";
import { useState, useEffect, useMemo } from "react";
import { useStore } from "stores/connect";
import ForwarderInputTypesStore, { ForwarderInputTypesActions } from "forwarder/stores/ForwarderInputTypesStore";
export const ForwarderWizardContext = React.createContext({
  selectedForwarder: void 0,
  setSelectedForwarder: () => {
  },
  selectedInputProfile: void 0,
  setSelectedInputProfile: () => {
  },
  inputTypes: {},
  inputDescriptions: {}
});
const ForwarderWizardProvider = ({ children }) => {
  const [selectedForwarder, setSelectedForwarder] = useState();
  const [selectedInputProfile, setSelectedInputProfile] = useState();
  const { forwarderInputDescriptions: inputDescriptions, forwarderInputTypes: inputTypes } = useStore(ForwarderInputTypesStore);
  const forwarderWizardContextValue = useMemo(
    () => ({
      selectedForwarder,
      setSelectedForwarder,
      selectedInputProfile,
      setSelectedInputProfile,
      inputDescriptions,
      inputTypes
    }),
    [inputDescriptions, inputTypes, selectedForwarder, selectedInputProfile]
  );
  useEffect(() => {
    if (!inputDescriptions || !inputTypes) {
      ForwarderInputTypesActions.list();
    }
  }, [inputDescriptions, inputTypes]);
  return /* @__PURE__ */ React.createElement(ForwarderWizardContext.Provider, { value: forwarderWizardContextValue }, children);
};
export default ForwarderWizardProvider;
